import paths from '../paths';
import { WorkflowClient } from './axiosWorkflowClient';
import { IUserFollowPayload } from './interface';

export const updateFollowStatusApi = async (config: IUserFollowPayload): Promise<boolean> => {
    try {
      const response = await WorkflowClient.post<boolean>(
        paths.updateFollowStatus(config?.type),
        config.formData
      );
      return response.data;
    } catch (e) {
      console.error('Error updating Follow status Api', e);
      return false;
    }
  };